import globals from 'scoreboard/components/globals'
import _ from 'lodash'

function key(datasetId) {
	return globals.databaseId + '-' + datasetId + '-datasetRequest'
}

function upgradeBetweenDateOperatorsToBetweenDateTime(request) {
	_.get(request,'filters', [])
		.filter(it => it.operator === 'between-date')
		.forEach(it => it.operator = 'between-date-time')
	datasetRequests.save(request)
	return request
}

/**
 * Remembers Dataset queries so that filters and other settings are retained when
 * switching back and forth between the Overview and Records tabs.
 */
var datasetRequests = {

	/**
	 * Returns a dataset request for the given dataset ID.  If a previous request for
	 * the dataset is available in the local storage, that one is used.  Otherwise,
	 * a new request with just the ID is constructed
	 */
	get: function(datasetId) {
		var request = sessionStorage[key(datasetId)]
		return request ?
			upgradeBetweenDateOperatorsToBetweenDateTime(JSON.parse(request)) :
				{ id: datasetId }
	},

	save: function(request) {
		sessionStorage[key(request.id)] = JSON.stringify(request)
	},

	remove: function(datasetId) {
		delete sessionStorage[key(datasetId)]
	}

}

export default datasetRequests

datasetRequests.__filename__ = 'datasets/dataset-requests.js'
